import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

axios.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("lhs_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("lhs_token");
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/auth/me`)
      .then(r => setUser(r.data))
      .catch(() => { localStorage.removeItem("lhs_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, extras = {}) => {
    const deviceId = localStorage.getItem("lhs_device_id") || (() => {
      const id = "web-" + Math.random().toString(36).slice(2, 12);
      localStorage.setItem("lhs_device_id", id);
      return id;
    })();
    const { data } = await axios.post(`${API}/auth/login`, {
      email, password, device_id: deviceId, ...extras,
    });
    localStorage.setItem("lhs_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    return data; // { id, email, email_verified:false, ... }
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); }
    catch (e) { console.warn("logout call failed", e?.message); }
    localStorage.removeItem("lhs_token");
    setUser(null);
  };
  const refreshMe = async () => {
    const { data } = await axios.get(`${API}/auth/me`);
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Erreur inconnue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return JSON.stringify(d);
}
